export const ROLES = {
  ADMIN: 'admin',
  PILOTE: 'pilote',
  ETUDIANT: 'etudiant'
};

// Vérification des permissions
export const hasPermission = (userRole, requiredRole) => {
  if (!userRole) return false;
  
  switch (requiredRole) {
    case ROLES.ADMIN:
      return userRole === ROLES.ADMIN;
    case ROLES.PILOTE:
      return userRole === ROLES.ADMIN || userRole === ROLES.PILOTE;
    case ROLES.ETUDIANT:
      return userRole === ROLES.ADMIN || userRole === ROLES.PILOTE || userRole === ROLES.ETUDIANT;
    default:
      return false;
  }
}; 